import type { CSSProperties } from 'react';

import { FeatBanIcon, FeatBookIcon, FeatBulbIcon, FeatCompassIcon, FeatMicIcon, FeatUsersIcon } from './icons';
import { SectionLabel } from './section-label';

/* "Pourquoi Naïa" feature grid, extracted from Landing.tsx (decomposition, Phase 4). */
export function Features() {
  const features = [
    { icon: <FeatMicIcon />, title: 'Parle et écoute', desc: "Naïa comprend les questions à l'oral et répond à voix haute. L'enfant n'a même pas besoin de savoir taper.", color: 'var(--naia-blue)' },
    { icon: <FeatBookIcon />, title: 'Aide aux devoirs', desc: 'Naïa guide sans faire à la place. Elle pose des questions, donne des pistes et encourage l\'autonomie.', color: 'var(--naia-green)' },
    { icon: <FeatCompassIcon />, title: 'Parcours adaptés', desc: 'Exercices calibrés sur le niveau et le programme scolaire. CP comme Terminale — Naïa s\'ajuste automatiquement.', color: 'var(--naia-tertiary)' },
    { icon: <FeatBulbIcon />, title: 'Stimule la curiosité', desc: 'Des histoires, des défis, des explications fascinantes. Naïa transforme l\'apprentissage en exploration.', color: 'var(--naia-blue)' },
    { icon: <FeatUsersIcon />, title: 'Tableau de bord enseignant', desc: 'Suivez la progression de vos élèves, assignez des exercices et créez des parcours sur mesure.', color: 'var(--naia-green)' },
    { icon: <FeatBanIcon />, title: 'Zéro distraction', desc: "Pas de fil d'actualité, pas de notifications. Un espace entièrement dédié à apprendre.", color: 'var(--naia-tertiary)' },
  ];
  return (
    <section className="section-light">
      <div className="landing-container">
        <div data-animate="">
          <SectionLabel>Pourquoi Naïa</SectionLabel>
          <h2 className="section-title">Une IA pensée pour apprendre,<br />pas pour l'engagement.</h2>
          <p className="section-sub">
            Contrairement aux grandes plateformes, Naïa n'a aucun intérêt à retenir l'utilisateur.
            Son seul objectif : apprendre, quel que soit le niveau.
          </p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div
              key={f.title}
              className="feature-card"
              style={{ '--feat-color': f.color } as CSSProperties}
              data-animate=""
              data-delay={String(Math.floor(i / 2) * 100)}
            >
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
